import type { IconName } from "@sagot/ui";

/** The tabs of Service reports (C16) in the order the mockup lists them; Orders arrives with its own phase. */
export const REPORT_TABS = ["overview", "sla", "teams", "agents", "agent-chats", "orgs", "csat", "deflection", "accuracy", "field"] as const;
/** Tabs only offered while the workspace may read their reports (plan and module): Field service. */
export const GATED_REPORT_TABS: readonly ReportTab[] = ["field"];
/** Offered only where the chat report answers: the `live_chat_ops` flag is on and the member may read analytics. */
export const CHAT_REPORT_TAB: ReportTab = "agent-chats";
export type ReportTab = (typeof REPORT_TABS)[number];
export const DEFAULT_REPORT_TAB: ReportTab = "overview";

export const REPORT_TAB_ICONS: Readonly<Record<ReportTab, IconName>> = {
  overview: "layout-dashboard",
  sla: "timer",
  teams: "users",
  agents: "headset",
  "agent-chats": "messages-square",
  orgs: "building-2",
  csat: "star",
  deflection: "bot",
  accuracy: "gauge",
  field: "wrench",
};

export function isReportTab(value: string | undefined): value is ReportTab {
  return REPORT_TABS.some((tab) => tab === value);
}

/** Presets of the date range select; `custom` shows the two date inputs. */
export const RANGE_KEYS = ["7d", "30d", "90d", "month", "custom"] as const;
export type RangeKey = (typeof RANGE_KEYS)[number];
export const DEFAULT_RANGE_KEY: RangeKey = "30d";
export const RANGE_PRESET_DAYS: Readonly<Record<"7d" | "30d" | "90d", number>> = { "7d": 7, "30d": 30, "90d": 90 };

/** The API refuses a longer period (`REPORT_MAX_RANGE_DAYS`). */
export const REPORT_MAX_DAYS = 400;
/** A report reads daily rollups; one read is good for a minute. */
export const REPORT_STALE_MS = 60_000;
/** The live "breached or at risk" table shows this many tickets. */
export const LIVE_BREACH_LIMIT = 10;
export const DAYS_PER_WEEK = 7;
/** Rows a chart shows before the rest are left to its table. */
export const CHART_TOP_ROWS = 8;
export const BREACHING_VIEW = "breaching_soon";
export const BACKLOG_BUCKETS = ["b0_1", "b1_3", "b3_7", "b7_30", "b30p"] as const;
export const SLA_METRICS = ["first_response", "next_response", "resolution", "onsite_response"] as const;

export const RANGE_PARAM = { range: "range", from: "from", to: "to", compare: "compare" } as const;
export const COMPARE_OFF = "0";
